import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import "./header.css";

export default function Header() {
  const navigate = useNavigate();

  function goToContact() {
    navigate("/");
    goToTop();
  }

  function goToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
      <div className="header">
        <div className="header--nav">
          <Link to={"/"} className="logo--title" id="header--tittle">
            Leandro<strong>Salles</strong>
          </Link>
          <div className="link">
            <a onClick={goToContact}>Home</a>
            <a href="#about">Sobre</a>
            {/* <a href="#services">Serviços</a> */}
            <a href="#skills">Habilidades</a>
            <a href="#portifolio">Portifólio</a>
            <a href="#curriculo">Currículo</a>
            <a href="#footer">Contato</a>
          </div>
        </div>
      </div>
  );
}
